<script setup lang="ts">
import QueueDoctorPage from "@/modules/queue/pages/QueueDoctorPage.vue";

definePage({
  meta: {
    layout: "blank",
  },
});
</script>

<template>
  <QueueDoctorPage />
</template>
